export const LABEL_FIELD = "label";

export function periodField(idx: number): string {
    return `period_${idx}`;
}
